<template>
    <h2 class="
      brand-values__title
      text-heading-xl
      text-heading-2xl-desktop
    ">
      {{ liquid.title }}
    </h2>
  <splide
    class="filter-bar__carousel"
    :has-track="false"
    :options="localConfig"
    :extensions="extensions"
  >
    <splide-track>
      <splide-slide
        v-for="(block, index) of liquid.blocks"
        :key="`brand-values-${index}`"
        class="brand-values__value"
      >
        <div class="brand-values__icon">
          <responsive-image
            v-if="block.icon"
            :image="block.icon"
            min-max="40-40"
            ratio="1:1"
          />
        </div>
        <div class="brand-values__value-content">
          <a :href="block.url" class="brand-values__anchortag">
          <h3
            class="brand-values__value-title text-heading-m"
            v-text="block.title"
          />
        </a>
        </div>
      </splide-slide>
    </splide-track>
  </splide>
</template>

<script>

/**
 * Vue: Brand values (brand-values)
 * -----------------------------------------------------------------------------
 * Media module with background image and 4 usp columns.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */

import ResponsiveImage from '~global/images/responsive-image'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'
import { values as breakpoints } from '~/config/breakpoints'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

export default {
  name: 'BrandValues',
  components: {
    ResponsiveImage,
    Splide,
    SplideSlide,
    SplideTrack,
  },
  props: {
    liquid: {
      type: Object,
      default: () => ({
        blocks: [],
      }),
    },
  },

  data() {
    return {

    }
  },

  mounted() {
    // not empty
  },

  beforeMount() {
    this.localConfig = {
      pagination: false,
      arrows: false,
      drag: 'free',
      autoScroll: {
        speed: 0.5,
      },
      focus: 'center',
      type: 'loop',
      mediaQuery: 'min',
      autoWidth: true,
      breakpoints: {
        [breakpoints.xl]: {
          destroy: true,
        },
      },
    }

    this.extensions = {
      AutoScroll,
    }
  },

  methods: {
    // not empty
  },
}
</script>

<style lang="scss">
@import './brand-values';
</style>
